import TrafficWarnings from "./TrafficWarnings";
import DispatchLayer from "./DispatchLayer";
import HeatmapLayer from "./HeatmapLayer";
import VehiclesLayer from "./VehiclesLayer";
import MyLocationsLayer from "./MyLocationsLayer";
import AssistNetworkLayer from "./AssistNetworkLayer";


export const GetAllPlugins = (map) => [
  new DispatchLayer(map),
  new VehiclesLayer(map),
  new MyLocationsLayer(map),
  new TrafficWarnings(map),
  new HeatmapLayer(map),
  new AssistNetworkLayer(map),
];


